<template>
  <div
    class="split-panel-shell glass-tab-panel--nested"
    :class="{ 'split-panel-shell--compact': compact }"
  >
    <header class="split-panel-shell__header">
      <div class="split-panel-shell__title-row">
        <i v-if="icon" :class="icon" class="split-panel-shell__icon" aria-hidden="true"></i>
        <h3 class="split-panel-shell__title">{{ title }}</h3>
        <span v-if="count != null && count !== ''" class="split-panel-shell__count">{{ count }}</span>
      </div>
      <div v-if="$slots['header-bar']" class="split-panel-shell__header-bar">
        <slot name="header-bar" />
      </div>
      <div v-else-if="compact && $slots.stats" class="split-panel-shell__header-stats">
        <slot name="stats" />
      </div>
      <div v-if="$slots.actions" class="split-panel-shell__actions">
        <slot name="actions" />
      </div>
    </header>

    <div v-if="$slots.account" class="split-panel-shell__account">
      <slot name="account" />
    </div>

    <div v-if="!compact && $slots.stats" class="split-panel-shell__stats">
      <slot name="stats" />
    </div>

    <div
      v-if="$slots.toolbar"
      class="split-panel-shell__toolbar"
      :class="{ 'split-panel-shell__toolbar--two-col': toolbarColumns === 2 }"
    >
      <slot name="toolbar" />
    </div>

    <div v-if="statusMessage" class="split-panel-shell__status" :class="`split-panel-shell__status--${statusType}`">
      {{ statusMessage }}
    </div>

    <div
      class="split-panel-shell__body"
      :class="{ 'split-panel-shell__body--single': layout === 'single' }"
    >
      <div
        v-if="$slots.list || layout === 'single'"
        class="split-panel-shell__list"
        :class="{ 'split-panel-shell__list--full': layout === 'single' }"
      >
        <slot name="list" />
        <slot v-if="layout === 'single'" name="content" />
      </div>
      <div v-if="layout === 'split'" class="split-panel-shell__detail">
        <slot name="detail" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplitPanelShell',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: '',
    },
    count: {
      type: [Number, String],
      default: null,
    },
    statusMessage: {
      type: String,
      default: '',
    },
    statusType: {
      type: String,
      default: 'info',
    },
    toolbarColumns: {
      type: Number,
      default: 1,
    },
    layout: {
      type: String,
      default: 'split',
      validator: (value) => ['split', 'single'].includes(value),
    },
    /** Denser header: stats sit beside the title; tighter toolbar padding */
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style src="../styles/split-panel-shell.css"></style>
